import { render, staticRenderFns } from "./SearchResultsPage.vue?vue&type=template&id=5e10e69a&"
import script from "./SearchResultsPage.vue?vue&type=script&lang=js&"
export * from "./SearchResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports